import React, { useState, useEffect } from "react";
import "../styles/ScrollToTopButton.css";
import { ArrowUp } from "lucide-react";

function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {

        const toggleVisibility = () => {
            setIsVisible(window.pageYOffset > 300);
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    }, []);

    if (!isVisible) return null;

    return (
        <button className="scroll-to-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            <ArrowUp size={24} />
        </button>
    );
}

export default ScrollToTopButton;
